export default __webpack_public_path__ + "static/media/O-151.1314ac52.png";